import React from "react";

import { Trans } from "@lingui/macro";

import { IntegrationProvider } from "@app/common/types";

import Link from "@rui/Link";
import Stack, { Row } from "@rui/Stack";
import { Img } from "@rui/styles";

import { AddProviderButton, DialogItemButton } from "./styles";

interface PushDialogItem {
  provider: IntegrationProvider;
  disabled: boolean;
  isConnected: boolean;
  onClick: () => void;
}

const PushDialogItem = ({
  disabled,
  provider,
  isConnected,
  onClick,
}: PushDialogItem) => {
  return (
    <DialogItemButton
      variant="outlined"
      className={disabled ? "disabled" : undefined}
      onClick={disabled ? undefined : onClick}
      startIcon={
        <Stack>
          <Img src={provider.icon} />
        </Stack>
      }
    >
      <Row variant="apart" flex={1}>
        {provider.displayNameShort}
        {!isConnected && (
          <AddProviderButton component={Link} to={provider.integrationUrl}>
            <Trans>Add</Trans>
          </AddProviderButton>
        )}
      </Row>
    </DialogItemButton>
  );
};

export default PushDialogItem;
